import { Navigate } from 'dui/router'
import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom'
import { AuthorizationCode, ForgotPassword, Login, Protected, ResetPassword, Signup } from 'authy-react'

import IframeOnlyRoute from '@/routes/iframe-only-route'
import ChatDashboard from '@/pages/chat/chat-dashboard'
import HomeHtmlPage from '@/pages/home-html-page'
import Questions from '@/pages/questions'
import AppLayout from '@/components/navigation/app-layout'
import UnansweredQuestions from '@/pages/unanswered-questions'
import { AuthWrapper } from '@/components/navigation/auth-wrapper'
import DashboardAnalytics from '@/pages/dashboard/dashboard-analytics'

const sidebar = (
  <img
    src="/auth-sidebar.jpg"
    alt="Authentication sidebar image"
    className="absolute inset-0 size-full object-cover"
  />
)

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/">
      <Route
        path="/chat-frame"
        element={
          <IframeOnlyRoute>
            <ChatDashboard />
          </IframeOnlyRoute>
        }
      />
      <Route path="/demo" element={<HomeHtmlPage />} />
      <Route path="/" element={<Protected element={<AppLayout />} />}>
        <Route index element={<DashboardAnalytics />} />
        <Route path="/questions" element={<Questions />} />
        <Route path="/unanswered" element={<UnansweredQuestions />} />
        <Route path="*" element={<Navigate to="/" replace preserveSearchParams />} />
      </Route>
      {import.meta.env.VITE_SIGNUP === 'true' && (
        <Route
          path="sign-up"
          element={
            <AuthWrapper>
              <Signup sidebar={sidebar} />
            </AuthWrapper>
          }
        />
      )}

      <Route
        path="auth"
        element={
          <AuthWrapper>
            <Login signup={import.meta.env.VITE_SIGNUP === 'true'} sidebar={sidebar} />
          </AuthWrapper>
        }
      />
      <Route
        path="forgot-password"
        element={
          <AuthWrapper>
            <ForgotPassword sidebar={sidebar} />
          </AuthWrapper>
        }
      />
      <Route
        path="reset-password"
        element={
          <AuthWrapper>
            <ResetPassword sidebar={sidebar} />
          </AuthWrapper>
        }
      />

      <Route
        path="authorization-code"
        element={
          <AuthWrapper>
            <AuthorizationCode />
          </AuthWrapper>
        }
      />
    </Route>,
  ),
)
